import { CookieSerializeOptions, serialize } from 'cookie';
import type { IncomingMessage, ServerResponse } from 'http';

const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;

class Cookies {
    private defaultConfig: CookieSerializeOptions = {
        domain: COOKIE_DOMAIN,
        path: '/',
        maxAge: 62 * 24 * 60 * 60,
    };

    constructor(
        private readonly ctx?: { req?: IncomingMessage, res?: ServerResponse },
    ) {}

    public save({ name, value, config }: { name: string, value: string | number, config?: CookieSerializeOptions }) {
        config = this.getCookieConfig(config);

        const serializedCookie = serialize(name, String(value), config); // `${name}=${value}; ${this.serializeCookieConfig(config)}`;
        if (this.ctx && this.ctx.res) {
            this.ctx.res.appendHeader('set-cookie', [serializedCookie]);
        } else {
            document.cookie = serializedCookie;
        }
    }

    public saveAll(cookies: Array<Parameters<Cookies['save']>[0]>) {
        cookies.forEach(cookie => this.save(cookie));
    }

    private getCookieConfig(config: CookieSerializeOptions = {}) {
        if (!config?.maxAge) {
            delete config?.maxAge;
        }

        return { ...this.defaultConfig, ...config };
    }
}

export default Cookies;
